import type { RouteLocationNormalized } from 'vue-router';
import VErrorLayout from '@/layouts/VErrorLayout/VErrorLayout.vue';
import { useUserStore } from '@/stores/user';

export const preloadUserInfo = async (to: RouteLocationNormalized) => {
  const userStore = useUserStore();
  if (!userStore.user) {
    try {
      await userStore.getUser();
    } catch (err) {
      to.matched.at(0)!.components!.default = VErrorLayout;
    }
  }
};
